import { useTranslation } from "react-i18next";
import { useGetInvoiceCountV1, useGetLitigeCountV1 } from "@/api/invoice";

type DisplayTypeSelectProps = {
  setDisplayType: React.Dispatch<React.SetStateAction<string>>;
  displayType: string;
};

export const DisplayTypeSelectClient = ({
  setDisplayType,
  displayType,
}: DisplayTypeSelectProps) => {
  const { t } = useTranslation("boClients");
  const displayTypesOptions = [
    { label: t("invoicesDisplayTypeSelect.invoices"), value: "invoice" },
    { label: t("invoicesDisplayTypeSelect.litiges"), value: "litige" },
  ];
  const { data: litigeCount } = useGetLitigeCountV1({
    paymentStatus: "TOBEPAID",
  });
  const { data: invoiceCount } = useGetInvoiceCountV1({
    paymentStatus: "TOBEPAID",
  });

  return (
    <div className="flex flex-row rounded-lg border border-gray-200 bg-white p-0.5">
      {displayTypesOptions.map((displayTypeOption) => {
        return (
          <button
            key={displayTypeOption.value}
            className={`flex flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-gray-700 focus:outline-hidden ${displayType === displayTypeOption.value ? "bg-brand700 text-white" : "bg-transparent text-gray-700 hover:text-gray-900"}`}
            onClick={() => setDisplayType(displayTypeOption.value)}
          >
            <span>{displayTypeOption.label}</span>
            <div
              className={`flex h-4 w-4 items-center justify-center rounded-full bg-red-700 p-3 text-white`}
            >
              {displayTypeOption.value === "invoice" ? invoiceCount : litigeCount}
            </div>
          </button>
        );
      })}
    </div>
  );
};
